import LabelHeading from '../../common/LabelHeading'
import { assets } from '../../../Assets/assets'
import ScrollArrowButtons from '../../common/ScrollArrowButtons'
import ServiceCard from './ServiceCard'
import { useRef } from 'react'
import services from "../../../config/services.json"


const Services = () => {

  const serviceData = [
    { img: assets.servicecardimg1, icon: assets.servicecardicon1, heading: 'Staff Augmentation', text: 'A flexible workforce strategy where companies hire external professionals  for specific projects or periods.' },
    { img: assets.servicecardimg2, icon: assets.servicecardicon2, heading: 'Direct Hire', text: 'Direct hiring is when a company hires an employee for a long-term position without using a third-party staffing agency.' },
    { img: assets.servicecardimg3, icon: assets.servicecardicon3, heading: 'RPO', text: 'A business solution where a company hires a third party to manage some or all of its recruitment.' },
    { img: assets.servicecardimg4, icon: assets.servicecardicon4, heading: 'Staff Augmentation', text: 'A flexible workforce strategy where companies hire external professionals  for specific projects or periods.' },
    { img: assets.servicecardimg2, icon: assets.servicecardicon2, heading: 'Direct Hire', text: 'Direct hiring is when a company hires an employee for a long-term position without using a third-party staffing agency.' },
    { img: assets.servicecardimg4, icon: assets.servicecardicon3, heading: 'RPO', text: 'A business solution where a company hires a third party to manage some or all of its recruitment.' },
  ]

  const scrollRef = useRef(null)

  const scrollLeft = () => {
    scrollRef.current.scrollBy({
      left: -320,
      behavior: "smooth"
    })
  }

  const scrollRight = () => {
    scrollRef.current.scrollBy({
      left: 320,
      behavior: "smooth"
    })
  }

  // console.log(services)

  return (
    <section className='w-full relative bg-[#F3F4FB]'>
      <img src={assets.servicebg} alt="bannerbg" className='absolute pointer-events-none top-0 left-0 w-full h-full z-0' />
      <div className='max-w-[1400px] w-full  mx-auto h-full px-6 xl:py-16 py-14'>
        <LabelHeading label={'Services'} heading={'Services We Offer'} text={'A flexible workforce strategy where companies hire external professionals  for specific projects or periods.'} />
        <div data-aos="fade-up" data-aos-duration="1000" className='space-y-3 mt-5'>
          <div className='flex justify-end items-center gap-2'>
            <ScrollArrowButtons scrollLeft={scrollLeft} scrollRight={scrollRight} />
          </div>
          <section ref={scrollRef} className='w-full no-scrollbar pb-3 flex gap-4 xl:gap-5 overflow-x-scroll overflow-y-hidden scroll-smooth snap-x snap-mandatory'>
            {
              services?.map((s, index) => (
                <ServiceCard index={index} key={index} id={s.id} img={serviceData[index]?.img} icon={serviceData[index]?.icon} heading={s.title} text={s?.description} />
              ))
            }
          </section>
        </div>
      </div>
    </section>
  )
}

export default Services